import { base } from './base';
import { calculatedData, inputs } from './relaxed';

export const columns = {
  ...base,
  ...inputs,
  ...calculatedData,
};
